import { render } from "./EventDetailsPage.vue?vue&type=template&id=219ee0a8"
import script from "./EventDetailsPage.vue?vue&type=script&lang=js"
export * from "./EventDetailsPage.vue?vue&type=script&lang=js"

import "./EventDetailsPage.vue?vue&type=style&index=0&id=219ee0a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__